import zLiv71 from "./zliv7 (1).webp";
import zLiv72 from "./zliv7 (2).webp";
import zLiv73 from "./zliv7 (3).webp";
import zLiv74 from "./zliv7 (4).webp";
import zLiv75 from "./zliv7 (5).webp";
import zLiv76 from "./zliv7 (6).webp";

const zLiv7 = [zLiv71, zLiv72, zLiv73, zLiv74, zLiv75, zLiv76];
export default zLiv7;
